var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable import/no-cycle */
import React from 'react';
import RecoSlider from '@empiriecom/module-components/RecoSlider';
import useConfig from '../hooks/useConfig';
import { StyledRecoWrapper } from './styles';
var Recommendations = function (_a) {
    var _b, _c, _d;
    var contentData = _a.contentData;
    var config = useConfig();
    var isStorybook = ((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.href.indexOf('http://localhost:6006/')) !== -1 || false;
    var recoApiUri = isStorybook
        ? "https://" + (((_d = (_c = config === null || config === void 0 ? void 0 : config.global) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.FRAGMENT_COMPANYID) || '') + ".empirie.cloud/api/inform/graphql/"
        : '/api/inform/graphql/';
    var cardLayout = false;
    var recoSliderConfig = {
        rdeRequest: {
            rdeType: 'prudsysHomePage',
            articleNo: '',
            cid: (contentData === null || contentData === void 0 ? void 0 : contentData.field_shop_id) || '',
        },
        pageTemplate: 'homepage',
        recoApi: recoApiUri,
    };
    var headline = contentData.field_text, headlineSpacer = contentData.field_headline_separator;
    if ((contentData === null || contentData === void 0 ? void 0 : contentData.type) === 'reco_prudsys' && (contentData === null || contentData === void 0 ? void 0 : contentData.field_reco_type) === 'ec-homepage') {
        return (React.createElement(StyledRecoWrapper, { className: "cms-recommendation-wrapper has-rendered", "data-testid": "cms-recommendation" },
            React.createElement(RecoSlider, __assign({ headline: headline, headlineElement: "div", headlineSpacer: headlineSpacer, cardLayout: cardLayout }, recoSliderConfig))));
    }
    return React.createElement("div", { className: "no-render-result", "data-testid": "cms-recommendation-no-result" });
};
export default Recommendations;
//# sourceMappingURL=index.js.map